//
// AGNES - Technical Support Web
//
// TechnicalSupportBrowseTechReportController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

angular.module("Agnes")
    .controller("TechnicalSupportBrowseTechReportController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "Blob", "FileSaver", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, Blob, FileSaver, oidc) {
            // Storage
            $scope.$storage = $sessionStorage.$default({
                technicalSupportBrowseTechReport: {
                    search: null,
                    //    status: [6], // just CLOsed
                    repairDateFrom: null,
                    repairDateTo: null,
                    areaCode: null,
                    componentCode: null,
                    fullKatashiki: null,
                    partNumber: null,
                    searchBySubject: null,

                    orderName: "CreateDate",
                    orderDesc: true
                }
            });

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Date pickers
            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.fromOpened = true;
            };

            $scope.toOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.toOpened = true;
            };

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.technicalSupportBrowseTechReport.orderName === orderName) {
                    $scope.$storage.technicalSupportBrowseTechReport.orderDesc = !$scope.$storage.technicalSupportBrowseTechReport.orderDesc;
                } else {
                    $scope.$storage.technicalSupportBrowseTechReport.orderName = orderName;
                    $scope.$storage.technicalSupportBrowseTechReport.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.technicalSupportBrowseTechReport.orderName === orderName) {
                    if ($scope.$storage.technicalSupportBrowseTechReport.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.loadAreaCodes = function () {
                $activity.start();
                $http
                    .get("/api/area-code", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.areaCodes = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.loadComponentCodesByArea = function (areaCode) {
                if (areaCode !== null) {
                    $activity.start();
                    $http
                        .get("/api/component-code/area/" + areaCode.id, {
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.componentCodes = response.data;
                        }, function (response) {
                            $notification.addError(response.status, response);
                        }).then(function () {
                            // $scope.componentCodesFiltered = null;
                            $activity.finish();
                        });
                } else {
                    $scope.componentCodes = null;
                }
            };

            // areaCodeChange - filter ComponentCodes
            $scope.$watch("$storage.technicalSupportBrowseTechReport.areaCode", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1 && newValue !== oldValue) {
                    $scope.loadComponentCodesByArea(newValue);

                    if (oldValue !== null) {
                        $scope.refresh();
                    }
                }
            });

            $scope.$watch("$storage.technicalSupportBrowseTechReport.componentCode", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1 && newValue !== oldValue) {
                    $scope.refresh();
                }
            });

            $scope.downloadTechReport = function (id) {
                _downloadForm(id, 'tech-report');
            }

            function _downloadForm(id, documentType) {
                $activity.start();
                $http
                    .get("/api/technical-support-form/" + documentType + "/download/" + id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        var data = new Blob([response.data.content], { type: response.data.type });
                        FileSaver.saveAs(data, response.data.fileName);
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    })
            }

            $scope.refresh = function () {
                $activity.start();
                $http
                    .get("/api/technical-support/browse-techreport/", //+ $scope.$storage.repairer.Id,
                        {
                            params: {
                                search: $scope.$storage.technicalSupportBrowseTechReport.search,
                                subject: $scope.$storage.technicalSupportBrowseTechReport.searchBySubject,
                                partNumber: $scope.$storage.technicalSupportBrowseTechReport.partNumber,
                                areaCodeId: $scope.$storage.technicalSupportBrowseTechReport.areaCode ? $scope.$storage.technicalSupportBrowseTechReport.areaCode.id : "",
                                componentCodeId: $scope.$storage.technicalSupportBrowseTechReport.componentCode ? $scope.$storage.technicalSupportBrowseTechReport.componentCode.id : "",
                                fullKatashiki: $scope.$storage.technicalSupportBrowseTechReport.fullKatashiki,
                                //  status: $scope.$storage.technicalSupportBrowseTechReport.status,
                                repairDateFrom: $scope.$storage.technicalSupportBrowseTechReport.from,
                                repairDateTo: $scope.$storage.technicalSupportBrowseTechReport.to
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.clearFilter = function () {
                $scope.$storage.technicalSupportBrowseTechReport.search = null;
                $scope.$storage.technicalSupportBrowseTechReport.searchBySubject = null;
                $scope.$storage.technicalSupportBrowseTechReport.partNumber = null;
                $scope.$storage.technicalSupportBrowseTechReport.areaCode = null;
                $scope.$storage.technicalSupportBrowseTechReport.componentCode = null;
                $scope.$storage.technicalSupportBrowseTechReport.fullKatashiki = null;
                $scope.$storage.technicalSupportBrowseTechReport.from = null;
                $scope.$storage.technicalSupportBrowseTechReport.to = null;
                $scope.refresh();
            };

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                $scope.loadAreaCodes();
                // $scope.loadComponentCodes();
                $scope.refresh();
            }
        }
    ]);